<template>
  <div class="Home lxn-w100">
    <div class="Home-main-wrapper lxn-w100 lxn-overflow-y-scroll lxn-overflow-x-hidden">
      <router-view/>
    </div>
    <BottomNav>
    </BottomNav>
  </div>
</template>

<script>
// @ is an alias to /src
import BottomNav from '@/components/Home/BottomNav.vue'

export default {
  name: 'home',
  components: {
    BottomNav
  },
}
</script>

<style>
  .Home {
    height: 100vh;
  }
  .Home-main-wrapper {
    height: calc(100% - 50px - 2px);
  }
</style>